import SplitBilling from "@/components/Orders/SplitBilling"
import usePaymentMethods from "@/hooks/usePaymentMethods"
import { useAppDispatch, useAppSelector } from "@/lib/hooks"
import {
  FormControl,
  FormHelperText,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
  CircularProgress,
  FormControlLabel,
  Switch,
} from "@mui/material"
import { useState, useEffect } from "react"
import {
  setSplitBilling,
  setPaymentMethod,
  setSplitPayments,
  setCashReceived,
  setSalesStatus,
} from "@/redux/slices/orderFormSlice"
import useSetting from "@/hooks/useSetting"

export function SalesStatus({
  controller,
  control,
  errors,
  register,
  watch,
  setValue,
}) {
  const Controller = controller
  const dispatch = useAppDispatch()
  const { settingData: salesStatusData, isLoading: salesStatusLoading } =
    useSetting("sales-status", "asc")
  const { salesStatus } = useAppSelector((state) => state.order)

  useEffect(() => {
    if (salesStatus && setValue) {
      const timeoutId = setTimeout(() => {
        setValue("sales_status", salesStatus, { shouldValidate: false })
      }, 0)

      return () => clearTimeout(timeoutId)
    }

    const dataArray = salesStatusData?.data
    const currentStatus = watch("sales_status")

    if (dataArray && dataArray.length > 0 && !currentStatus) {
      const defaultId = dataArray[0].id

      setValue("sales_status", defaultId)
      dispatch(setSalesStatus(defaultId))
    }
  }, [salesStatus, setValue, salesStatusData])

  return (
    <div className="flex rounded-2xl bg-white flex-col flex-1">
      <Typography
        variant="h6"
        className="font-semibold mb-2 flex justify-between mr-4"
      >
        <div> Sales Status</div>
      </Typography>

      <div className="flex justify-between flex-1">
        {salesStatusLoading ? (
          <div className="flex justify-center py-4">
            <CircularProgress size={24} />
          </div>
        ) : (
          <FormControl>
            <Controller
              name="sales_status"
              control={control}
              render={({ field: { onChange, value } }) => {
                const currentValue = value || salesStatus || null

                return (
                  <>
                    <ToggleButtonGroup
                      fullWidth
                      exclusive
                      value={currentValue || ""}
                      onChange={(event, newValue) => {
                        if (newValue !== null) {
                          dispatch(setSalesStatus(newValue))
                          onChange(newValue)
                        }
                      }}
                      aria-label="sales status toggle"
                      className="flex flex-wrap"
                    >
                      {salesStatusData?.data?.map((method) => (
                        <ToggleButton
                          key={method.id}
                          value={method.id}
                          color={value === method.id ? "primary" : ""}
                          className="flex-1 py-2 text-sm font-medium"
                        >
                          {method.display_name}
                        </ToggleButton>
                      ))}
                    </ToggleButtonGroup>

                    {errors.sales_status && (
                      <FormHelperText error>
                        {errors.sales_status.message}
                      </FormHelperText>
                    )}
                  </>
                )
              }}
            />
          </FormControl>
        )}
      </div>
    </div>
  )
}
